import type { JSX } from 'react';

import { RecentSupportersList } from './components/RecentSupportersList';

export function RecentSupporters(): JSX.Element {
	return (
		<section
			className="bg-background-base flex max-h-[441px] w-full flex-col px-4 pb-0 pt-8 md:p-12 md:pb-0"
			data-qa="recent-supporters-module-new"
		>
			<RecentSupportersList />
		</section>
	);
}
